import '@reach/tabs/styles.css';
import './Tabs.css';

export { Tab, TabList, TabPanel, TabPanels, Tabs } from '@reach/tabs';
